import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mappedStatus',
  standalone: false,
})
export class MappedStatusPipe implements PipeTransform {
  private readonly statusMap: Record<string, string> = {
    success: 'Successful',
    failed: 'Failed',
    completed: 'Completed',
    'in progress': 'In progress',
  };

  transform(status?: string | null): string {
    if (!status) {
      return '-';
    }

    const normalizedStatus = status.trim().toLowerCase();
    return this.statusMap[normalizedStatus] ?? status;
  }
}
